import {Provider} from '@angular/core';
import {SpinnerPort} from '@shared/application/ports/spinner/spinner.port';
import {SpinnerAdapter} from '@shared/infrastructure/spinner/spinner.adapter';

export const SpinnerProvider: Provider = {
  provide: SpinnerPort,
  useClass: SpinnerAdapter,
}
